export default __webpack_public_path__ + "static/media/remove-item.681b0c2a.svg";